import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook"
import { useMemo, useState } from "react"
import { useLazyGetPropertyByIdQuery } from "../../../services/bClientApi"
import { showError } from "../../../redux/counter/counterSlice"
import { useAppDispatch } from "../../../redux/store"
import { PropertyType } from "../../../Types/propertyTypes"
import QuickSelectModal, { QuickSelectOption } from "../QuickSelectModal/QuickSelectModal"

export function SelectPropertyModal(props: {
    active: boolean,
    onClose: () => void,
    onSelect: (propertyData: PropertyType | PropertyType[]) => void,
    message?: string
    title?: string
    multiSelect?: boolean
    filterFn?: (property: PropertyType) => boolean
}) {

    const {
        active,
        onClose,
        onSelect,
        message = "Please select a property",
        title = "Choose Property",
        multiSelect = false,
        filterFn,
    } = props

    const [disabled, setDisabled] = useState(false)
    const dispatch = useAppDispatch()

    const {
        myProperties,
        isLoading,
        isFetching,
    } = useMyProperties()

    const [getPropertyById] = useLazyGetPropertyByIdQuery()

    const options: QuickSelectOption[] = useMemo(() => {
        return Object.keys(myProperties)
            .filter((propertyId) => {
                const property = myProperties[propertyId]
                if (filterFn && !filterFn(property)) return false
                return true
            })
            .map((propertyId) => ({
                id: propertyId,
                label: myProperties[propertyId].title.split(' - ')[0],
            }))
    }, [myProperties, filterFn])

    const handleSelect = async (selected: string | string[]) => {
        setDisabled(true)
        if (multiSelect && Array.isArray(selected)) {
            const propertyDataList: PropertyType[] = []
            for (const propId of selected) {
                const propertyData = await getPropertyById(propId).unwrap().catch((err) => {
                    console.log(err)
                })
                if (propertyData && propertyData._id) {
                    propertyDataList.push(propertyData)
                }
            }
            if (propertyDataList.length > 0) {
                onSelect(propertyDataList)
            } else {
                dispatch(showError('Could not find selected properties'))
            }
        } else if (typeof selected === 'string') {
            const propertyData = await getPropertyById(selected).unwrap().catch((err) => {
                console.log(err)
            })
            if (propertyData && propertyData._id) {
                onSelect(propertyData)
            } else {
                dispatch(showError('Could not find that property'))
            }
        }
        setDisabled(false)
        onClose()
    }

    return (
        <QuickSelectModal
            active={active}
            onClose={onClose}
            onSelect={handleSelect}
            options={options}
            title={title}
            message={message}
            multiSelect={multiSelect}
            isLoading={isLoading || isFetching}
            disabled={disabled}
            filterPlaceholder="Filter Properties"
        />
    )
}